import { jsxs, jsx } from "react/jsx-runtime";
const IconEditOutlineSvg = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: 16,
    height: 16,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    fill: "currentColor",
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx("path", { d: "M17.25 3.417c-1.167-1.167-3.333-1.167-4.5 0l-9.167 9.166c-.083.084-.166.25-.25.417L2.5 17.167c-.083.25 0 .583.25.75.167.166.333.25.583.25H3.5l4.167-.834a.458.458 0 0 0 .416-.25l9.167-9.166a3.169 3.169 0 0 0 0-4.5ZM7.083 15.75l-2.666.5.5-2.667 7.166-7.166 2.167 2.166-7.167 7.167Zm9-9-.666.667L13.25 5.25l.667-.667C14.5 4 15.5 4 16.083 4.583c.584.584.584 1.584 0 2.167Z" })
    ]
  }
);
export {
  IconEditOutlineSvg
};
